import React, { useState } from 'react';
import {
    Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    TextField, Select, MenuItem, FormControl, InputLabel, Button, Pagination, Grid, Typography
} from '@mui/material';
import GetAppIcon from '@mui/icons-material/GetApp';
import { getConfig } from '../adm/ConfigContext';
import { getDatabase, ref, get, query, push, orderByChild, limitToLast } from 'firebase/database';
import firebaseApp, { KEY_LINK, KEY_REF } from '../adm/admin/firebaseConfig';
import { runTransaction, serverTimestamp } from 'firebase/database';
const mesesNumeros = {
    janeiro: 1, fevereiro: 2, marco: 3, abril: 4, maio: 5, junho: 6, julho: 7, agosto: 8, setembro: 9, outubro: 10, novembro: 11, dezembro: 12,
};

const months = [
    { value: '', label: 'Todos' },
    { value: 'janeiro', label: 'Janeiro' },
    { value: 'fevereiro', label: 'Fevereiro' },
    { value: 'marco', label: 'Março' },
    { value: 'abril', label: 'Abril' },
    { value: 'maio', label: 'Maio' },
    { value: 'junho', label: 'Junho' },
    { value: 'julho', label: 'Julho' },
    { value: 'agosto', label: 'Agosto' },
    { value: 'setembro', label: 'Setembro' },
    { value: 'outubro', label: 'Outubro' },
    { value: 'novembro', label: 'Novembro' },
    { value: 'dezembro', label: 'Dezembro' },
];

export default function DataTable({ data, itemscope, itemtype, itemprop }) {
    const config = getConfig();
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [selectedYear, setSelectedYear] = useState('');
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedVereador, setSelectedVereador] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(parseInt(e.target.value, 10));
    };

    const handleYearChange = (e) => {
        setSelectedYear(e.target.value);
    };

    const handleMonthChange = (e) => {
        setSelectedMonth(e.target.value);
    };

    const handleVereadorChange = (e) => {
        setSelectedVereador(e.target.value);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };
    const uniqueYears = [...new Set(data.map((item) => String(item.ano)))];
    const uniqueVereadores = [...new Set(data.map((item) => item.vereador || 'N/A'))];



    const filteredAndSortedData = () => {
        let filteredItems = [...data];

        if (selectedYear) {
            filteredItems = filteredItems.filter(
                (item) => String(item.ano) === String(selectedYear)
            );
        }

        if (selectedMonth) {
            filteredItems = filteredItems.filter(
                (item) =>
                    typeof item.mes === 'string' &&
                    item.mes.toLowerCase() === selectedMonth.toLowerCase()
            );
        }

        if (selectedVereador) {
            filteredItems = filteredItems.filter(
                (item) => (item.vereador || 'N/A') === selectedVereador
            );
        }

        if (searchTerm) {
            const lowerSearch = searchTerm.toLowerCase();
            filteredItems = filteredItems.filter((item) =>
                item.title.toLowerCase().includes(lowerSearch)
            );
        }

        filteredItems.sort((a, b) => {
            const anoA = String(a.ano);
            const anoB = String(b.ano);

            if (anoA !== anoB) {
                // compara numericamente, mas garante que ambos são strings válidas
                return parseInt(anoB, 10) - parseInt(anoA, 10);
            }

            if (mesesNumeros[a.mes] !== mesesNumeros[b.mes]) {
                return mesesNumeros[b.mes] - mesesNumeros[a.mes];
            }

            if (a.numero !== undefined && b.numero !== undefined) {
                return b.numero - a.numero;
            }

            if (a.dia !== undefined && b.dia !== undefined) {
                return b.dia - a.dia;
            }

            if (a.numero !== undefined) return -1;
            if (b.numero !== undefined) return 1;

            if (a.dia !== undefined) return -1;
            if (b.dia !== undefined) return 1;

            return 0;
        });

        const startIndex = (currentPage - 1) * itemsPerPage;
        return filteredItems.slice(startIndex, startIndex + itemsPerPage);
    };


    const registrarDownload = async (item) => {
        if (!item?.href || !item?.title) return;

        try {
            const agora = new Date();
            const ano = agora.getFullYear().toString();
            const mes = String(agora.getMonth() + 1).padStart(2, '0');
            const dia = String(agora.getDate()).padStart(2, '0');

            const databaseInstance = getDatabase(firebaseApp);
            const arquivosRef = query(ref(databaseInstance, `dashboards/downloads/${ano}/${mes}/${dia}/arquivos`));

            await push(arquivosRef, {
                nome: item.title.trim(),
                arquivo: item.href,
                baixadoem: agora.toISOString().slice(0, 19).replace('T', ' '),
                itemtype: itemtype || null,
                ip: 'IP não capturado'
            });

            await runTransaction(ref(databaseInstance, `dashboards/downloads/${ano}/${mes}/${dia}`), (current) => {
                if (current === null) {
                    return {
                        count: 1,
                        updated: serverTimestamp()
                    };
                }
                return {
                    ...current,
                    count: (current.count || 0) + 1,
                    updated: serverTimestamp()
                };
            });

            // console.log(`Download registrado: ${item.title}`);
        } catch (err) {
            console.error('Erro ao registrar download:', err);
        }
    };


    const handleBaixar = (item) => (e) => {
        window.open(item.href, '_blank');
        // e.preventDefault();    
        registrarDownload(item);
    };
    const displayedData = filteredAndSortedData();

    return (
        <Box sx={{ padding: 0.5, maxWidth: '1200px', mx: 'auto' }} itemscope itemtype={itemtype}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={3}>
                    <TextField
                        fullWidth
                        label="Buscar por nome"
                        variant="outlined"
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Itens por página</InputLabel>
                        <Select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            label="Itens por página"
                        >
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                            <MenuItem value={50}>50</MenuItem>
                            <MenuItem value={100}>100</MenuItem>
                            <MenuItem value={2000}>Todos</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Filtrar por ano</InputLabel>
                        <Select
                            value={selectedYear}
                            onChange={handleYearChange}
                            label="Filtrar por ano"
                        >
                            <MenuItem value="">Todos os anos</MenuItem>
                            {uniqueYears
                                .sort((a, b) => b - a)
                                .map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <FormControl fullWidth variant="outlined">
                        <InputLabel>Filtrar por mês</InputLabel>
                        <Select
                            value={selectedMonth}
                            onChange={handleMonthChange}
                            label="Filtrar por mês"
                        >
                            <MenuItem value="">Todos os meses</MenuItem>
                            {months.map((month) => (
                                <MenuItem key={month.value} value={month.value}>
                                    {month.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {(itemtype === 'requerimentos' || itemtype === 'projetodelei') && (
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth variant="outlined">
                            <InputLabel>Filtrar por vereador</InputLabel>
                            <Select
                                value={selectedVereador}
                                onChange={handleVereadorChange}
                                label="Filtrar por vereador"
                            >
                                <MenuItem value="">Todos os vereadores</MenuItem>
                                {uniqueVereadores
                                    .sort((a, b) => a.localeCompare(b))
                                    .map((vereador) => (
                                        <MenuItem key={vereador} value={vereador}>
                                            {vereador}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                )}
            </Grid>

            {displayedData.length === 0 && (
                <Typography variant="body2" color="textSecondary" align="center" sx={{ mb: 2 }}>
                    Não há itens a exibir
                </Typography>
            )}

            <TableContainer component={Paper}>
                <Table>
                    <TableHead sx={{ backgroundColor: config?.color }} itemscope itemtype={itemtype}>
                        <TableRow itemprop={itemprop}>
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Nome</TableCell>
                            {displayedData.some(item => item.mes) && (
                                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Mês</TableCell>
                            )}
                            {displayedData.some(item => item.ano) && (
                                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Ano</TableCell>
                            )}
                            {(itemtype === 'requerimentos' || itemtype === 'projetodelei') && (
                                <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Vereador</TableCell>
                            )}
                            <TableCell sx={{ color: '#fff', fontWeight: 'bold' }}>Arquivo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {displayedData.map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.title ? item.title.toUpperCase() : ''}</TableCell>
                                {typeof item.mes === 'string' ? (
                                    <TableCell>
                                        {months.find((month) => month.value === item.mes)?.label || item.mes.toUpperCase()}
                                    </TableCell>
                                ) : (
                                    <TableCell>-</TableCell>
                                )}
                                {item.ano && (
                                    <TableCell>{item.ano}</TableCell>
                                )}
                                {(itemtype === 'requerimentos' || itemtype === 'projetodelei') && (
                                    <TableCell>{item.vereador || 'N/A'}</TableCell>
                                )}
                                <TableCell>
                                    <Button
                                        variant="contained"
                                        onClick={handleBaixar(item)}
                                        target="_blank"
                                        size="small"
                                        startIcon={<GetAppIcon />}
                                        sx={{
                                            backgroundColor: config?.color,
                                            color: '#FFFFFF',
                                            textTransform: 'uppercase',
                                            '&:hover': {
                                                color: config?.color,
                                                backgroundColor: config?.colorSecondary,
                                            },
                                            padding: '6px 12px',
                                            borderRadius: '20px',
                                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                        }}
                                    >
                                        Baixar
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box display="flex" justifyContent="center" mt={3}>
                <Pagination
                    count={Math.ceil(data.length / itemsPerPage)}
                    page={currentPage}
                    onChange={handlePageChange}
                    sx={{
                        '& .MuiPaginationItem-root': {
                            color: 'black',
                        },
                        '& .Mui-selected': {
                            backgroundColor: config?.color,
                            color: 'white',
                        },
                    }}
                />
            </Box>
        </Box>
    );
}